import { Button } from '@mantine/core';
import { Link, variants } from '@uag/react-core';
import { DOKA_360_PRODUCT_URL } from '@uag/welcome-shared/src/utils/externalLinks';
import { Trans, useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router';

import { DOKA_360_COMPLETE_REGISTRATION_URL } from '../../shared/externalLinks';

type Doka360AvailableLocationState = {
    countryCode: string;
};

export const Doka360AvailableView = () => {
    const { t } = useTranslation();

    const { state } = useLocation();
    const { countryCode } = (state as Doka360AvailableLocationState | null) ?? {};

    if (!countryCode) {
        return <Navigate to="/requests/create" replace />;
    }

    const handleContinue = () => {
        const searchParams = new URLSearchParams({ countryCode });
        window.location.href = `${DOKA_360_COMPLETE_REGISTRATION_URL}/new?${searchParams.toString()}`;
    };

    return (
        <div className="gap-2xl flex flex-col">
            <div className="gap-lg flex flex-col">
                <h1 className="text-4xl">{t('getStartedDoka360')}</h1>

                <p>
                    <Trans
                        components={{
                            doka360Link: (
                                <Link href={DOKA_360_PRODUCT_URL} target="_blank" variant={variants.link.external} />
                            ),
                        }}
                        i18nKey="doka360.availableForCountry"
                    />
                </p>
            </div>
            <Button fullWidth onClick={handleContinue}>
                {t('startDoka360Registration')}
            </Button>
        </div>
    );
};
